var map = {
	"./camera.svg": 1097,
	"./error-icon.svg": 1098,
	"./heart-result.svg": 1099,
	"./heart.svg": 1100,
	"./hf-logo-black.svg": 410,
	"./logo-title.svg": 1101,
	"./logo.png": 1102,
	"./logo.svg": 1103,
	"./logout.svg": 411,
	"./mark.svg": 1104,
	"./mask.svg": 1105,
	"./note-icon.svg": 412,
	"./oxygen-result.svg": 1106,
	"./oxygen.svg": 1107,
	"./points.svg": 1108,
	"./pressure-result.svg": 1109,
	"./pressure.svg": 1110,
	"./resp-rate-result.svg": 1111,
	"./resp-rate.svg": 1112,
	"./result-mark.svg": 851,
	"./sdnn-result.svg": 1113,
	"./sdnn.svg": 1114,
	"./sex-female.svg": 1115,
	"./sex-male.svg": 1116,
	"./start-button.svg": 1117,
	"./stress-result.svg": 1118,
	"./stress.svg": 1119,
	"./warning-icon.svg": 1120,
	"./warning.svg": 853
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 852;